import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import messages from 'containers/CourtManagerLegalProceedings/Provision/messages';
import { translate } from 'containers/services/translate';
import FileIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/file-icon';

export interface RiskTableProps {
  intl: IntlShape;
  provisionInfo: any;
  handleGetRiskDetail: Function;
}

export const RiskTable: React.FC<RiskTableProps> = ({
  provisionInfo,
  handleGetRiskDetail,
  ...props
}): JSX.Element => {
  return (
    <>
      <div className="riskBloc">
        <FileIcon /> <span>{translate(messages.ProductRisk, props)}</span>
      </div>
      <div>
        <Table>
          <TableHead>
            <TableRow className="row">
              <TableCell align="left" className="headerTitle">
                {translate(messages.Risk, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.management, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.responsability, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.provisions, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.regulation, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.field1, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.field2, props)}
              </TableCell>
              <TableCell align="left" className="headerTitle">
                {translate(messages.field3, props)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {provisionInfo.map((el: any) => {
              return (
                <TableRow
                  data-testid="risk-detail"
                  className="row"
                  onClick={handleGetRiskDetail(el)}
                >
                  <TableCell align="left" className="riskInfo">
                    {el.riskName}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.managementMode}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.responsibilityRate}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.provision}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.regulation}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.provisionRecEmis}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.recoursEmisRec}
                  </TableCell>
                  <TableCell align="left" className="riskInfo">
                    {el.recoursRec}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default injectIntl(RiskTable);
